import { all, call, put, takeLatest } from 'redux-saga/effects';

import * as actions from '../redux/regions';
import { actions as errorActions } from '@dragonfruit/redux/error';

import { apiFetchRegions } from '../services/apis';

export function* fetchRegionFlow(action) {
  try {
    const forTutorRegistration = action.payload.forTutorRegistration;
    const response = yield call(apiFetchRegions, forTutorRegistration);

    yield put(actions.fetchRegionsSuccess(response.data));
  } catch (err) {
    yield put(actions.fetchRegionsFailed(err.message));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([takeLatest(actions.FETCH_REGIONS, fetchRegionFlow)]);
}



// WEBPACK FOOTER //
// ./app/sagas/regions.js